import { ApplicationName } from '@performance/ui'

import { environment } from '@env'
import { DialogApplication } from '@shared/dialogs/dialog-application/dialog-application'

export const IMAGE_BASE_PATH = environment.staticsUrlAssets + 'img/applications/'

const PORTABLE_DEVICE_INSTALLER_CONFIG = [
  {
    os: 'ios',
    type: 'primary',
    extension: 'IOS',
  },
  {
    os: 'android',
    type: 'primary',
    extension: 'APK',
  },
]

export const INSTALLER_CONFIG_BY_APPLICATION = {
  [ApplicationName.Desktop]: [
    {
      os: 'windows',
      type: 'primary',
      extension: 'EXE',
    },
    {
      os: 'macos',
      type: 'primary',
      extension: 'DMG',
    },
  ],
  [ApplicationName.Mobile]: PORTABLE_DEVICE_INSTALLER_CONFIG,
  [ApplicationName.LivePro]: PORTABLE_DEVICE_INSTALLER_CONFIG,
}

export const SHOW_OS_ICON_APPLICATIONS = [
  ApplicationName.Mobile,
  ApplicationName.Desktop,
  ApplicationName.LivePro,
]

export const NOT_INSTALLATION_ALLOWED = {
  [ApplicationName.Mobile]: (dialogInstance: DialogApplication) =>
    dialogInstance.isTablet || dialogInstance.isDesktop,
  [ApplicationName.Desktop]: (dialogInstance: DialogApplication) =>
    dialogInstance.isTablet || dialogInstance.isMobile,
  [ApplicationName.LivePro]: (dialogInstance: DialogApplication) =>
    dialogInstance.isMobile || dialogInstance.isDesktop,
}
